import React, { useState } from 'react';
import PropTypes from 'prop-types';

// components
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from 'ui-connect';
import Translate from 'components/Translate';

import style from './MaxConnectionsDialog.module.css';

const MAX_CONNECTIONS_COUNT = 1000;

const MaxConnectionsDialog = ({ isUserConnectionsOverLimitation, nameToDisplay, shouldModalOpen, onCloseModal }) => {
    const [isModalOpen, setIsModalOpen] = useState(shouldModalOpen);

    const message = isUserConnectionsOverLimitation ? (
        <Translate ns="connections" content="max_connection_error_modal_content" />
    ) : (
        <Translate
            ns="connections"
            content="max_connection_error_modal_content_2"
            params={{ 0: nameToDisplay, 1: MAX_CONNECTIONS_COUNT }}
        />
    );
    return (
        <div className={style.maxConnectonsModalContainer}>
            <Dialog
                open={isModalOpen}
                closeBtn={true}
                onClose={() => {
                    setIsModalOpen(false);
                    onCloseModal();
                }}
            >
                <DialogTitle>
                    <Translate ns="connections" content="max_connection_error_modal_title" />
                </DialogTitle>
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setIsModalOpen(false);
                            onCloseModal();
                        }}
                    >
                        <Translate ns="common" content="ok" />
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

MaxConnectionsDialog.propTypes = {
    isUserConnectionsOverLimitation: PropTypes.bool.isRequired,
    nameToDisplay: PropTypes.string.isRequired,
    shouldModalOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired
};

export default MaxConnectionsDialog;
